import { render, staticRenderFns } from "./ResourceComments.vue?vue&type=template&id=1d28a057&scoped=true&"
import script from "./ResourceComments.vue?vue&type=script&lang=js&"
export * from "./ResourceComments.vue?vue&type=script&lang=js&"
import style0 from "./ResourceComments.vue?vue&type=style&index=0&id=1d28a057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d28a057",
  null
  
)

/* custom blocks */
import block0 from "./ResourceComments.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VIcon,VSpacer,VTextarea})
